define('views/blocks/ProductSidedishView',['underscore', 'jquery', 'backbone', 'app','SubView'],
function(_,jQuery,BackBone,app,SubView){
        return BackBone.View.extend(SubView).extend({
            initialize:function(options){
                var view = this;
                view.sidedish = options.sidedish;
                view.subviews = [];
                view.start();
            },
            start:_.noop,
            validate:function(){
                return this.sidedish.validateSelection();
            },
            getEmptiness:function(){
                return this.sidedish.getEmptiness();
            },
            warn:function(){
                var min = this.sidedish.getQuantityMin();
                app.banNotice(app.t(min > 1 ? 'Vous devez sélectionner %s produits':'Vous devez sélectionner un produit', 'Product', min));
            }
        })
})
;
